var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfferSentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F0EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 18.875a4.5 4.5 0 0 1 4.5-4.5h4.5a4.5 4.5 0 0 1 4.5 4.5v.308c1.399.128 2.786.295 4.161.5 2.181.327 3.714 2.224 3.714 4.375v4.55c0 1.817-1.1 3.529-2.904 4.129A37.088 37.088 0 0 1 30 34.625c-4.095 0-8.036-.663-11.722-1.888-1.803-.6-2.904-2.312-2.904-4.129v-4.55c0-2.15 1.533-4.048 3.714-4.374a73.137 73.137 0 0 1 4.161-.502v-.307zm11.25 0v.136a74.228 74.228 0 0 0-9 0v-.136a2.25 2.25 0 0 1 2.25-2.25h4.5a2.25 2.25 0 0 1 2.25 2.25zM30 31.25A1.125 1.125 0 1 0 30 29a1.125 1.125 0 0 0 0 2.25z",
    fill: "#6053C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 38.6v-4.194c.335.183.692.34 1.07.466A39.34 39.34 0 0 0 30 36.875c4.338 0 8.519-.703 12.43-2.003a6.46 6.46 0 0 0 1.07-.466V38.6c0 2.178-1.57 4.091-3.785 4.385-3.179.422-6.422.64-9.715.64s-6.536-.218-9.715-.64C18.07 42.691 16.5 40.778 16.5 38.6z",
    fill: "#6053C7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferSentIcon);
export default __webpack_public_path__ + "static/media/offer-sent-icon.d427417a8d6fce78648ba01934c1eee7.svg";
export { ForwardRef as ReactComponent };